/* eslint-disable camelcase */
import type { ShoppingCart } from '@/interfaces/checkout/shopping-cart';
import AnalyticsEvent from './AnalyticsEvent';
import { documentReady } from '../../global/helper';
import type GaItemList from './GaItemList';

export default class AddPaymentInfo extends AnalyticsEvent {
	fireBeginCheckout(): void {
		super.fireGoogleAnalyticsEventOrAddListener('add_payment_info');
	}

	fireBeginCheckoutDomReady(): void {
		documentReady(() => { this.fireBeginCheckout(); });
	}

	static createInstance(currency: string, price: number, paymentType: string, offerData: ShoppingCart) {
		const itemList: GaItemList = {
			currency,
			value: 0,
			payment_type: paymentType,
			items: [{
				item_id: offerData.Travel.Hotel.IffCode.toString(),
				item_name: offerData.Travel.Hotel.Name,
				item_brand: offerData.Travel.TourOperator.Code,
				item_category: offerData.Travel.Hotel.Country,
				item_category2: offerData.Travel.Hotel.Region,
				item_category3: offerData.Travel.Hotel.City,
				item_variant: offerData.Travel.TravelType,
				price,
				quantity: 1,
			}]
		};
		return new AddPaymentInfo(itemList);
	}
}
